export default "__VITE_ASSET__BozrpT6H__"